import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AppointmentSurveyDto } from "../types/appointmentSurvey";

export default function appointmentSurveyReducer(
  state: AppointmentSurveyDto = initialState.appointmentSurvey,
  action: AnyAction
): AppointmentSurveyDto {
  switch (action.type) {
    case actionTypeKeys.PATCH_APPT_SURVEY_SUCCESS:
    case actionTypeKeys.GET_APPT_SURVEY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
